"use client";

import { useState } from "react";
import { MessageCircle, ShoppingBag } from "lucide-react";

interface ProductActionsProps {
    productName: string;
    productId: string;
    price: number | null;
}

export function ProductActions({ productName, productId, price }: ProductActionsProps) {
    const [quantity, setQuantity] = useState(1);
    const phoneNumber = "94707336060"; // Replace with actual business number

    const handleQuantityChange = (delta: number) => {
        setQuantity(prev => Math.max(1, prev + delta));
    };

    const generateWhatsAppLink = () => {
        const message = `Hi CNS, I would like to place an order.
        
Product: ${productName}
SKU: ${productId}
Price: ${price ? `LKR ${price.toLocaleString()}` : 'Call for Price'}
Quantity: ${quantity}

Please confirm availability and delivery details.`;

        return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    };

    return (
        <div className="flex flex-col sm:flex-row gap-4 mb-8">
            {/* Quantity Selector */}
            <div className="flex items-center border border-gray-300 rounded-xl px-4 h-14 w-fit bg-white">
                <button
                    onClick={() => handleQuantityChange(-1)}
                    className="text-gray-500 hover:text-blue-600 px-2 font-medium"
                >
                    -
                </button>
                <span className="w-12 text-center font-bold text-gray-900">{quantity}</span>
                <button
                    onClick={() => handleQuantityChange(1)}
                    className="text-gray-500 hover:text-blue-600 px-2 font-medium"
                >
                    +
                </button>
            </div>

            {/* Order Button */}
            <a
                href={generateWhatsAppLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-grow h-14 bg-green-600 text-white rounded-xl font-bold text-sm hover:bg-green-700 transition-all shadow-lg shadow-green-200 flex items-center justify-center gap-2"
            >
                <ShoppingBag className="w-5 h-5" /> Order via WhatsApp
            </a>

            {/* General Chat Button (Optional, can act as 'Ask Question') */}
            <a
                href={`https://wa.me/${phoneNumber}?text=Hi CNS, I have a question about ${productName} (${productId}).`}
                target="_blank"
                rel="noopener noreferrer"
                className="h-14 w-14 rounded-xl border border-gray-300 flex items-center justify-center text-gray-600 hover:bg-gray-50 hover:border-gray-400 transition-all group"
                title="Ask a Question"
            >
                <MessageCircle className="w-6 h-6 group-hover:text-blue-600 transition-colors" />
            </a>
        </div>
    );
}
